import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import CardVisa from "../assets/icons/CardVisa.vue";
import CardMastercard from "../assets/icons/CardMastercard.vue";
import CardAmericanExpress from "../assets/icons/CardAmericanExpress.vue";
import CardDiscover from "../assets/icons/CardDiscover.vue";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#022E52",
        secondary: "#B32C2D",
        accent: "#B9B9B9",
        error: "#B32C2D",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
      },
    },
  },
  icons: {
    iconfont: "mdiSvg",
    values: {
      cardVisa: {
        component: CardVisa,
      },
      cardMastercard: {
        component: CardMastercard,
      },
      cardAmericanExpress: {
        component: CardAmericanExpress,
      },
      cardDiscover: {
        component: CardDiscover,
      },
    },
  },
});
